import Vue from 'vue'
import { DEFAULT_HEADERS } from '../constants';

// import {achost} from '../constants';


const state = () => ({
    articles: [],
    benefits: [],
    blurbs: [],
    tortoiseArticles: []
})
//https://apex-connect.avalanchestudios.com/api/v1/acp/articles
//${achost}/api/v1/acp/articles
const actions = {
    fetchArticles(context) {
        return Vue.axios.post(`https://apex-connect.avalanchestudios.com/api/v1/acp/articles`, {}, {
            headers: DEFAULT_HEADERS
        }).then((resp) => {
            context.commit('setArticles', resp.data.articles);
        })

    }
}

const mutations = {
    setArticles(state, articles) {
        state.benefits = articles.filter((article) => {
            return article.category === 'benefit';
        })
        state.blurbs = articles.filter((article) => {
            return article.category === 'blurb';
        })
        state.tortoiseArticles = articles.filter((article) => {
            return article.category === 'tortoiseArticle';
        })
        state.articles = articles;
    } 
}

export const news = {
    namespaced: true,
    actions,
    mutations,
    state
}